import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@chakra-ui/react';
import { ModalProps, useModal } from 'src/modules/modal';

import useEventHistory from './useEventHistory';

const ModalExpiration: React.FC<
  ModalProps<{ eventId: string; title: string; content: string }>
> = ({ onClose, eventId, title, content }) => {
  const eventHistory = useEventHistory();

  const onClick = () => {
    // Limpa a flag genérica de expiração
    sessionStorage.removeItem('checkout_expired');
    // Limpa todas as flags específicas de checkout para evitar problemas com múltiplas abas
    // Isso garante que o usuário possa iniciar novos checkouts sem restrições após decidir voltar ao evento
    Object.keys(sessionStorage).forEach(key => {
      if (key.startsWith('checkout_expired_')) {
        sessionStorage.removeItem(key);
      }
    });

    onClose();
    eventHistory.replace(`/event/${eventId}`);
  };

  return (
    <Modal
      onClose={onClose}
      isOpen
      isCentered
      motionPreset="slideInBottom"
      closeOnEsc={false}
      closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{content}</ModalBody>
        <ModalFooter justifyContent="flex-start">
          <Button onClick={onClick} rounded="full" colorScheme="blue" px={10}>
            Voltar para o evento
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const useModalExpiration = () => {
  return useModal(ModalExpiration);
};

export default useModalExpiration;
